module.exports = __webpack_public_path__ + "static/media/search-btn.fead840a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/search-btn.svg
// module id = 226
// module chunks = 0